<template>
  <div class="mt-3" v-if="roundInfo">
    Die aktuelle Tabelle
    <!-- Tabelle -->
    <div class="card-sakali container-fluid">
      <div v-for="(score, index) in roundInfo.scores"
           :key="score.id"
           class="row"
           :class="{'sakali-highlight':loggedIn && (score.team.coach && score.team.coach.id === user.id),
                          'border-bottom border-success':index +1 == league.climbUpCount,
                          'border-top border-danger': index == roundInfo.scores.length - league.dropOutCount,
                          'even': index % 2 == 0}">
        <!-- Pfeile für Tabellenbewegungen -->
        <div class="col-1 ps-0 text-nowrap text-center px-0">
                    <span v-if="score.lastRank > 0 && score.rank < score.lastRank">
                        <fas icon="chevron-up"
                             size="xs"
                             class="text-success"></fas>
                    </span>
          <span v-if="score.lastRank > 0 && score.rank > score.lastRank">
                        <fas icon="chevron-down"
                             size="xs"
                             class="text-danger"></fas>
                    </span>
        </div>
        <div class="col-1 text-nowrap text-end ps-0 mx-0"
             style="width: 12px;"
             :class="{live: live}">
          <span v-if="score.rank == index +1">{{ score.rank }}.</span>
        </div>
        <div class="col-1 px-0 mx-0">
          <team-emblem size="21" :emblem-id="score.team.emblemId"/>
        </div>
        <div class="col-6 text-nowrap text-truncate ps-0 ms-0">
          {{ score.team.name }}
        </div>
        <div class="col-1 text-end px-0"
             :class="{live}">
          {{ score.goalsTendence }}
        </div>
        <div class="col-1 pe-0 ms-1 text-end" style="font-weight: bolder"
             :class="{live}">
          {{ score.points }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  props: {
    league: Object,
    roundInfo: Object
  },
  computed: {
    ...mapGetters(['loggedIn', 'user']),
    live() {
      return this.roundInfo.running
    }
  }
}
</script>
